import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

import type {
  CustomTextEntity,
  CreateCustomTextEntityRequest,
} from 'views/App/Portal/Policy/_types/customTextEntities';

export async function createCustomTextEntity(
  manualId: string,
  data: CreateCustomTextEntityRequest,
  signal?: AbortSignal
): Promise<CustomTextEntity> {
  return fetcher({
    method: 'POST',
    url: `${baseApiUrl()}/lexiverse/text-entity/v1/manuals/${manualId}/text-entities/custom`,
    body: data,
    options: { signal },
  });
}

export async function updateCustomTextEntity(
  manualId: string,
  textEntityId: string,
  data: CreateCustomTextEntityRequest,
  signal?: AbortSignal
): Promise<CustomTextEntity> {
  return fetcher({
    method: 'PUT',
    url: `${baseApiUrl()}/lexiverse/text-entity/v1/manuals/${manualId}/text-entities/custom/${textEntityId}`,
    body: data,
    options: { signal },
  });
}
